<template>
  <div class="downloadUrl">
    <!-- <a href="javascript:void(0)" v-if="type == 'pdf'" @click="lookPdf">{{ url }}</a> -->
    <a :href="url">{{ url }}</a>
  </div>
</template>
<script>
export default {
  props: {
    url: {},
  },
  computed: {
    type() {
      if (this.url) {
        let arr = this.url.split(".");
        let type = arr[arr.length - 1];
        return type;
      }
      return "";
    },
  },
  methods: {
    lookPdf() {
      this.$router.push("/pdf?url=" + this.url);
    },
  },
};
</script>
<style lang="scss" scoped>
.downloadUrl {
  width: 100%;
  a {
    display: block;
    width: 250px;
    color: #3399ff;
    word-wrap: break-word;
  }
}
</style>
